import { useGrfqRfq } from '@paradigm/features/src/unified-rfqs/ui/rfq-context';
import ScreenPriceAction from '../rfqs/action/ScreenPriceAction';

export default function ScreenPrices() {
  const rfq = useGrfqRfq();

  return (
    <ScreenPriceAction
      productCode={rfq.product_codes[0]}
      isQtyNormalized={false}
    />
  );
}
